var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { Popover as ReactTinyPopover } from 'react-tiny-popover';
const ReactPopover = (_a) => {
    var { className, fixed = false, children } = _a, rest = __rest(_a, ["className", "fixed", "children"]);
    return (React.createElement(ReactTinyPopover, Object.assign({ containerClassName: cx(className, { fixed }) }, rest), children));
};
export const Popover = styled(ReactPopover) `
  ${({ theme }) => theme.typography.body}
  z-index: 10000;
  background: ${({ theme }) => theme.palette.system.background};
  min-width: 200px;
  padding: 4px 0;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
  border-radius: 4px;

  &.fixed {
    position: fixed !important;
  }
`;
//# sourceMappingURL=styles.js.map